import { Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useState } from 'react'

type Props = {
  buttonProps: ButtonProps
  onClick: () => void
  dialogMessage: React.ReactNode
  children: React.ReactNode
  dialogTitle: string
  confirmText?: string
  buttonDisabled?: boolean
}

export const ConfirmButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClick = () => {
    props.onClick()
    setIsOpen(false)
  }
  return (
    <>
      <Button fullWidth disabled={props.buttonDisabled} onClick={() => setIsOpen(true)} {...props.buttonProps}>
        {props.children}
      </Button>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-describedby="dialogcontent"
        aria-labelledby="dialogtitle"
      >
        <DialogTitle color="primary" component="h2" variant="h2" id="dialogtitle">
          {props.dialogTitle}
        </DialogTitle>
        <DialogContent id="dialogcontent">{props.dialogMessage}</DialogContent>
        <DialogActions>
          <Button color="secondary" variant="outlined" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={onClick}>
            {props.confirmText || 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
